<template>
  <table-list ref="table"
    idKey="id"
    :listConfig="listConfig"
    :apis="apis"
    :btn-config="btnConfig"
    @handleBtn="handleBtn"
    :btnConfig="btnConfig | filterBtnsRole($route)"
  >
    <div slot="images" slot-scope="data">
      <el-image v-for="(url, index) in data.row.images.split(',')" :key="index"
                style="width: 50px; height: 50px;margin-right: 5px" :src="url"
                :preview-src-list="data.row.images.split(',')"/>
    </div>
  </table-list>
</template>

<script>
import config from "./config/reporting.config";
export default {
  data() {
    return {
      ...config(),
    };
  },
  methods: {
    async handleBtn(key, list) {
      if (key === 'dispose') {
        if (list.length !== 1) this.$error('请至少选择一项操作');
        const ids = list.map(item => item.id);
        await this.$ajax(this.apis.dispose, ids)
        await this.$refs.table.getList();
      }
    }
  }
};
</script>
